import { FunctionComponent } from 'react'
import { useMount } from 'react-use'
import styled from 'styled-components'
import type { OurIntlShape } from '@/i18n/typing'
import { Wrapper } from '@/utils/export-pptx/components/slides/styles'
import { PptxObjectType } from '@/utils/export-pptx/constants'
import type { ContactSlide } from '@/utils/export-pptx/types/slide'

interface SlideProps {
  slide: ContactSlide
  onSlideReady?: (slide: ContactSlide) => void
  formatMessage: OurIntlShape['formatMessage']
}

const SlideComponent: FunctionComponent<SlideProps> = ({
  slide,
  onSlideReady,
  formatMessage,
}) => {
  useMount(() => {
    onSlideReady?.(slide)
  })

  return (
    <Wrapper>
      <Title data-pptx-object={PptxObjectType.Text}>
        {formatMessage({ id: 'general:pptx_title_contact_us' })}
      </Title>
      <Info>
        {slide.payload.company && (
          <InfoItem>
            <InfoItemTitle data-pptx-object={PptxObjectType.Text}>
              {formatMessage({ id: 'general:field_name_company' })}
            </InfoItemTitle>
            <InfoItemValue data-pptx-object={PptxObjectType.Text}>
              {slide.payload.company}
            </InfoItemValue>
          </InfoItem>
        )}
        {slide.payload.tel && (
          <InfoItem>
            <InfoItemTitle data-pptx-object={PptxObjectType.Text}>
              {formatMessage({ id: 'general:field_name_tel' })}
            </InfoItemTitle>
            <InfoItemValue data-pptx-object={PptxObjectType.Text}>
              {slide.payload.tel}
            </InfoItemValue>
          </InfoItem>
        )}
        {slide.payload.email && (
          <InfoItem>
            <InfoItemTitle data-pptx-object={PptxObjectType.Text}>
              {formatMessage({ id: 'general:field_name_email' })}
            </InfoItemTitle>
            <InfoItemValue data-pptx-object={PptxObjectType.Text}>
              {slide.payload.email}
            </InfoItemValue>
          </InfoItem>
        )}
      </Info>
    </Wrapper>
  )
}

const InfoItemTitle = styled.div`
  font-size: 24px;
  font-weight: 700;
  line-height: 33px;
  color: ${({ theme }): string => theme.colors.text.primary};
`

const InfoItemValue = styled.div`
  font-size: 20px;
  line-height: 28px;

  color: ${({ theme }): string => theme.colors.text.secondary};
`

const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const Info = styled.div`
  position: absolute;
  top: 296px;
  left: 180px;
  display: flex;
  flex-direction: column;
  gap: 51px;
`

const Title = styled.div`
  position: absolute;
  top: 169px;
  left: 173px;
  color: ${({ theme }): string => theme.colors.text.primary};
  font-size: 64px;
  font-weight: 700;
  line-height: 70px;
  letter-spacing: 0.24em;
`

export default SlideComponent
